//@flow

import * as React from "react"
import { TweenMax, Cubic } from "gsap"
import { Hero, LocationName } from "./UI"
import CammTitle from "./CammTitle"

type Props = { locationName: string }

class DefaultHero extends React.Component<Props> {
  title: ?HTMLElement
  locationName: ?HTMLElement

  componentDidMount() {
    if (this.title && this.locationName) {
      TweenMax.set(this.title, { opacity: 0, y: -20 })
      TweenMax.set(this.locationName, {
        opacity: 0,
        y: -20,
        borderColor: "rgba(15,45,73,0)"
      })
      TweenMax.staggerTo(
        [this.title, this.locationName],
        1.5,
        { opacity: 1, y: 0, ease: Cubic.easeOut },
        1
      )
      TweenMax.to(this.locationName, 1, {
        borderColor: "rgba(15,45,73,1)",
        ease: Cubic.easeOut,
        delay: 1.5
      })
    }
  }

  render() {
    return (
      <Hero>
        <div ref={el => (this.title = el)}>
          <CammTitle height="445px" width="664px" />
        </div>
        <LocationName innerRef={el => (this.locationName = el)}>
          {this.props.locationName}
        </LocationName>
      </Hero>
    )
  }
}

export default DefaultHero



// WEBPACK FOOTER //
// ./src/Kiosk/AttractLoopView/DefaultHero.js